jQuery(function($) {

   $('.to_nicedropdown-js').niceSelect();


   /* test scroll gsap */
   // var box = querySelector('.HomeBg');
   // var cicle_yellow = querySelector('.c_yellow');
    if ( $( ".g_circle" ).length ) {  
    gsap.to('.g_circle', {
       yPercent: -20,
       ease: "none",
       scrollTrigger: {
         trigger:'.HeaderPageBTxt',
          start: "center center", // the default values
       //   end: "center center",
         scrub: true
       }, 
     });
    }

    /* Anim elt txt */
      if ( $( ".AnimEltTxt" ).length ) {  
      const boxes = gsap.utils.toArray('.AnimEltTxt');
      boxes.forEach(box => {
        //  var img = box.querySelector('.AnimEltTxt');
          gsap.from(box, 2,{
           x: -30,
           opacity:0,
           ease: Power2.easeOut,
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
            end: "center center",
            scrub: false
          }, 
        });

      });
     }


    if ( $( ".little-bar_anim" ).length ) { 
     gsap.to('.little-bar_anim', {
       x: 200,
       ease: "none",
       scrollTrigger: {
         trigger:'.BTitleBar',
       //   start: "top center", // the default values
       //   end: "center center",
         scrub: true
       }, 
     });
   }
   if ( $( ".sPresTeam-Img" ).length ) { 
     // img parralax //
      gsap.from('.sPresTeam-Img img', {
       y: 180,
       ease: "none",
       scrollTrigger: {
         trigger:'.sPresTeam-Container',
       //   start: "top center", // the default values
          end: "bottom center",
         scrub: true
       }, 
     });
    }
     


     /* PageService - Flexible content - Img gauche */
     if ( $( ".FlexibleS-ImgL-CR" ).length ) {  
      const boxes = gsap.utils.toArray('.FlexibleS-ImgL-CR');
      boxes.forEach(box => {
          var img = box.querySelector('.FlexibleS-ImgL');
          gsap.from(img, {
          y: 180,
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "bottom center",
            scrub: true
          }, 
        });

      });
     }
  
      /* PageService - Flexible content - Full width avec bordure */
     if ( $( ".FlexibleS-Fwidth" ).length ) {  
      const boxes_flexiblefullw = gsap.utils.toArray('.FlexibleS-Fwidth');
      boxes_flexiblefullw.forEach(box => {
          var vertical_bar = box.querySelector('.FlexibleS-Fwidth--bg');
          gsap.to(vertical_bar, {
         height: '100%',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
            end: "bottom center",
            scrub: true
          }, 
        });

      });
     }

         /* PageService - Flexible bloc intermittence */
     if ( $( ".Group_Intermi" ).length ) {  
      const boxes = gsap.utils.toArray('.Group_Intermi');
      boxes.forEach(box => {
          var img = box.querySelector('.Group_Intermi-Img');
          gsap.from(img, {
           yPercent: 10,
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
            end: "center center",
            scrub: true
          }, 
        });

      });
     }

     if ( $( ".ImgSep__inner" ).length ) {  

     /* Page equipe */
      gsap.from('.ImgSep__inner', {
       ease: "none",
      xPercent: -3,
       scrollTrigger: {
         trigger:'.ImgSep',
       //   start: "top center", // the default values
       //   end: "center center",
         scrub: true
       }, 
     });

    }


      


    var h_top_header = 20;
    var header = $('#masthead');

    var $active_menu,$dest_sub_menu;
   var $parent_allbigmenu = $('.ContainerMenuAnim-Middle');

   $(".menu-toggle").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        $('body').addClass('open_menu');
        if($active_menu) disable_sub_menu($active_menu,$dest_sub_menu);

      }else{
         $('body').removeClass('open_menu');
         if($active_menu) disable_sub_menu($active_menu,$dest_sub_menu);
      }
   });  


   /* *****************  */
    /* SMOOTH SCROLL :  INTRO AUTRE PAGE  */
  /* *****************  */

      var menuItems = $('.js-toScrollAnchor');
      var offsetTop;
       menuItems.click(function(e){

      var href = $(this).attr("href"),
          offsetTop = href === "#" ? 0 : $(href).offset().top-header.height() - 30;
    
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 600);
       
        e.preventDefault();
    });


  //  $("#footer-menu > li.menu-item-has-children > a, #primary-menu > li.menu-item-has-children > a").click(function(e){
  //    e.preventDefault();
  //    $(this).parent().toggleClass('focus');
  // });


   /******************************************/
    /********** SCROLL - NAV -----------/
  /******************************************/
 $(window).scroll(function () {
      action_on_scroll();
  });

  function action_on_scroll(){

     if ($(window).scrollTop() > 0){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
      }else{
         header.removeClass("Masthead--sticky");
        $("body").removeClass('header--sticky');
      }

   }

 

    $("#primary-menu > li.smenu > a").click(function(e){
       // e.preventDefault();
       // $(this).parent().toggleClass('focus');
       // $(this).parent().parent().parent('focus-one-submenu');

        $active_menu = $(this);
        $dest_sub_menu = $('.header-sub[data-link-id="'+$(this).attr('href')+'"]'); 
        active_sub_menu($active_menu, $dest_sub_menu);

    });

    $('body').on('click', ".header-sub-title", function(e) {
      disable_sub_menu($active_menu,$dest_sub_menu);
    });

    function active_sub_menu($active_menu,$dest_sub_menu){
       $parent_allbigmenu.addClass('active_width_smenu');
       $('.header-sub').removeClass('active');
        if($active_menu){
          $active_menu.addClass('is-hover');
      }  
       $dest_sub_menu.addClass('active');
    }

     function disable_sub_menu($active_menu,$dest_sub_menu){
       if($active_menu){
          $active_menu.removeClass('is-hover');
       } 
       $dest_sub_menu.removeClass('active');
       $parent_allbigmenu.removeClass('active_width_smenu');
    }


  $('.SentenceSlide').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        autoplay:true,
      //  arrows:false,
        autoplaySpeed: 4000,
        fade: true,
        pauseOnHover:false,
        cssEase: 'linear',
        nextArrow: '<button class="SentenceSlide-Btn"><i class="icon-play"></i><svg viewBox="0 0 80 80"><circle id="circlestroke" cx="40" cy="40" r="38" stroke-width="2"/></svg></button>',


    });

  $('.SentenceSlide').on("beforeChange", function (event, slick, currentSlide, nextSlide){
 //   console.log($(slick[0]).find("button.SentenceSlide-Btn"));
    var $elt = $(this).find("button.SentenceSlide-Btn");
    if($elt.hasClass('animPlay')){
       $elt.removeClass("animPlay");
       $elt.addClass("animPlay2");
    }else{
       $elt.removeClass("animPlay2");
      $elt.addClass("animPlay");
    }
});

   $(".SentenceSlide-Btn").click(function(e){
      $(this).addClass('desable_animation');

    });

    $(".arrow_back").click(function(e){
      $(this).parent().parent().parent().find('.icon-close').trigger( "click" );

    });


   


   /******************************************/
    /********** LIGHTBOX MORPH ! -----------/
  /******************************************/


    (function() { 
      "use strict";
      var docElem = window.document.documentElement, didScroll, scrollPosition;

      // trick to prevent scrolling when opening/closing button
      function noScrollFn() {
        window.scrollTo( scrollPosition ? scrollPosition.x : 0, scrollPosition ? scrollPosition.y : 0 );
      }

      function noScroll() {
        window.removeEventListener( 'scroll', scrollHandler );
        window.addEventListener( 'scroll', noScrollFn );
      }

      function scrollFn() {
        window.addEventListener( 'scroll', scrollHandler );
      }

      function canScroll() {
        window.removeEventListener( 'scroll', noScrollFn );
        scrollFn();
      }

      function scrollHandler() {
        if( !didScroll ) {
          didScroll = true;
          setTimeout( function() { scrollPage(); }, 60 );
        }
      }

      function scrollPage() {
        scrollPosition = { x : window.pageXOffset || docElem.scrollLeft, y : window.pageYOffset || docElem.scrollTop };
        didScroll = false;
      }

      scrollFn();
      
      if ( $( ".morph-button" ).length ) {

         const morphbutton = gsap.utils.toArray('.morph-button');

           morphbutton.forEach(box => {

                new UIMorphingButton( box, {
                closeEl : '.icon-close',
                onBeforeOpen : function() {
                  // don't allow to scroll
                  noScroll();

                },
                onAfterOpen : function() {
                  // can scroll again
                  canScroll();
                  // add class "noscroll" to body
                  classie.addClass( document.body, 'noscroll' );
                  // add scroll class to main el
                  classie.addClass( box, 'scroll' );
                },
                onBeforeClose : function() {
                  // remove class "noscroll" to body
                  classie.removeClass( document.body, 'noscroll' );
                  // remove scroll class from main el
                  classie.removeClass( box, 'scroll' );
                  // don't allow to scroll
                  noScroll();
                },
                onAfterClose : function() {
                  // can scroll again
                  canScroll();
                }
              } );
        });

      }

    })();

  //  $('.to_link_t').click(function(e){
  //   $(this).find('button').trigger( "click" );
  // });

  // $(".to_link_t button").click(function(e) {
  //       e.stopPropagation();
  //  });






  /* *****************  */
    /*  DUPLICATA PAGE AJAX - RECAPTCHA FORM CONTACT PAGE*/
  /* *****************  */

  //this submit part need to be move to the recaptacha validation script after succeed.

  var ToDisplayMessage_contact = $('#message_form_contact');
  ToDisplayMessage_contact.hide();
  $('.form_leg_contact').submit(function(e) {
    e.preventDefault();
    
    var This_new_form = $(this);
    This_new_form.addClass('form__to_load');

    var action_this_form = 'form_contact_leg';

      grecaptcha.execute('6Ldd6_gfAAAAAG-y1Nl18VS4ITFpzZ6K62cz--SP', {action: action_this_form}).then(function(token) {
      document.getElementById('form_contactleg_token').value=token;
     // var formData = This_new_form.serialize();
     
        // AJAX POUR VERIFIER LE CAPTCHA //
         $.ajax({
              url : string_value.ajaxurl,
              method : 'POST',
              //dataType: "JSON",
              processData: false,
              contentType: false,
              data:new FormData(This_new_form[0])
              //  security: $('#security_duplicata_form_inpage').val()
          }).done(function(response) {
           
          // $('#nom_contact, #email_contact, #object_contact, #message_contact').val(""); // PODOM A MODIFIER CA //
            This_new_form.removeClass('form__to_load');
            ToDisplayMessage_contact.removeClass('error').addClass('success');
            ToDisplayMessage_contact.slideDown(300);
           ToDisplayMessage_contact.html('<p>'+string_value.info_sent_ok+'</p>');
            
            $('body').addClass('succes_form').removeClass('overview');
            $('.fs-title').removeClass('intro-form');
            $('.fs-title .BigSubtitle').html(string_value.mess_thx+' <br/><span class="color_yellow">'+string_value.get_back_you+'</span>');
            
            $('.form_leg_contact').slideUp(800, function(){
               
            });

           // var parsed = JSON.parse(response);
           // console.log(parsed);
           //   console.log("ID de l'insert"+parsed.id_insertion);
         

        }).fail(function(data) {
         /// ICI, PAS LE BON CAPTCHA OU PROBLEME DE FORMULAIRE
          This_new_form.removeClass('form__to_load');
        // console.log('PB DE FORMULAIRE');
        // console.log(data.responseText);
         ToDisplayMessage_contact.removeClass('success').addClass('error');
         ToDisplayMessage_contact.slideDown(300);
         ToDisplayMessage_contact.html('<p><strong>'+string_value.validation_error+'</strong></p><p>'+data.responseText+'</p>');

      });

    }, function (reason) {
      // ICI LE CAPTCHA QUI VEUT PAS S'EXECUTER
        This_new_form.removeClass('form__to_load');
        ToDisplayMessage_contact.removeClass('success').addClass('error');
        ToDisplayMessage_contact.slideDown(300);
        ToDisplayMessage_contact.html('<p><strong>'+string_value.validation_error+'</strong>.</p><p>'+reason+'</p>');
        console.log(reason);

   });

  });





});




